/**
 * 区分 sequenceResetType（numbering_rules.sequence_reset_type）
 * 出典：要件書 5.2
 */
export const SEQUENCE_RESET_TYPE_VALUES = ['yearly', 'monthly', 'none'] as const;

export type SequenceResetType = (typeof SEQUENCE_RESET_TYPE_VALUES)[number];

export const SEQUENCE_RESET_TYPE_LABELS: Readonly<Record<SequenceResetType, string>> = {
  yearly: '年ごと',
  monthly: '月ごと',
  none: 'なし',
};
